import React, { Component } from "react";
import copy from "copy-to-clipboard";
import { withTranslation } from "react-i18next";
import { message } from "antd";

import { getCandidateVideoMp4 } from "../utils/videos";

import Button from "./Button";

import styled from "styled-components/macro";

const TIME_FIX = 0;

const CopyLinkButton = styled(Button)`
  &,
  &.ant-btn.ant-btn-sm {
    display: flex;
    align-items: center;
    font-size: 9px;
    height: 20px;
    padding-left: 6.6px;
    padding-right: 4px;
    pointer-events: auto;
    border-color: #d0d9ff !important;
    float: right;

    /* Icon styles */
    .anticon.anticonlink svg {
      fill: ${({ theme }) => theme["@primary"]} !important;
    }
    & > .anticon + span,
    & > span + .anticon {
      margin-left: 4px;
    }
  }
`;

const CandidateVideoContainer = styled.div`
  display: flex;
  height: 100%;
  justify-content: center;
  video {
    background: black;
    max-height: 440px;
    &::cue {
      background: ${({ theme }) => theme["@primary"]};
      font-size: 18px;
    }
  }
`;

class CandidateVideo extends Component {
  constructor(props) {
    super(props);
    this.myRef = React.createRef();
  }
  componentDidMount() {
    this.setupSubtitles();
  }

  setupSubtitles() {
    if (typeof VTTCue === "undefined") return; // Disable subtitles in edge for now
    const track = this.myRef.current.addTextTrack(
      "subtitles",
      "Preguntas",
      "en"
    );
    track.mode = "showing";

    this.props.videoMetadata &&
      this.props.videoMetadata.questions &&
      this.props.videoMetadata.questions.map(question => {
        return track.addCue(
          new VTTCue(
            (question.start - TIME_FIX) / 1000,
            question.duration / 1000 + (question.start - TIME_FIX) / 1000,
            question.title
          )
        );
      });
  }

  render() {
    const { t } = this.props;
    const handleCopyOpportunityLink = () => {
      copy(getCandidateVideoMp4(this.props.video));
      message.success(
        t("opportunity:process.candidateDetails.copiedVideoLink")
      );
    };

    return (
      <>
        <CopyLinkButton
          data-test={"copy-candidate-video-link"}
          icon="link"
          onClick={handleCopyOpportunityLink}
          size="small"
          shape="round"
        >
          <span style={{ color: "#343A40" }}>
            {t("opportunity:process.candidateDetails.copyVideoLink")}
          </span>
        </CopyLinkButton>
        <CandidateVideoContainer>
          <video
            ref={this.myRef}
            alt="CV en video"
            controls
            // autoPlay
            onEnded={this.props.toggleVideo}
          >
            <source
              src={getCandidateVideoMp4(this.props.video)}
              type="video/mp4"
            />
            {t("global:videoSupport")}
          </video>
        </CandidateVideoContainer>
      </>
    );
  }
}

export default withTranslation()(CandidateVideo);
